import axios from "axios";

// The Rayalchat server's address. There is no default: a hard-coded LAN address would be wrong on every other network.
// Set React_App_RAYALCHAT_BACKEND_URL in the frontend .env (e.g. https://chat.example.com); the page says so while it is empty.
// Plain axios on purpose: this is another server, our client / user headers must not be sent to it.
const backendUrl = () => (process.env.React_App_RAYALCHAT_BACKEND_URL || "").replace(/\/+$/, "");

const RayalchatDeviceService = {
  isConfigured: () => Boolean(backendUrl()),
  getAllDeviceInfos: async () => {
    const RAYALCHAT_BACKEND_URL = backendUrl();
    if (!RAYALCHAT_BACKEND_URL) {
      throw new Error("React_App_RAYALCHAT_BACKEND_URL is not set");
    }
    try {
      const response = await axios.get(`${RAYALCHAT_BACKEND_URL}/api/getAllDeviceInfos`);
      return response.data;
    } catch (error) {
      console.error("Error fetching device infos from Rayalchat backend:", error);
      throw error;
    }
  },
};

export default RayalchatDeviceService;
